import { render, staticRenderFns } from "./LeadInfos.vue?vue&type=template&id=669ec3c7&"
import script from "./LeadInfos.vue?vue&type=script&lang=js&"
export * from "./LeadInfos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports